/**
 * Network Security Layer - Provides CSP headers, clickjacking protection,
 * and secure request headers for all admin operations.
 */

export class NetworkSecurity {
  static setupCSP() {
    const meta = document.createElement('meta');
    meta.httpEquiv = 'Content-Security-Policy';
    meta.content = `
      default-src 'self';
      script-src 'self' 'unsafe-inline' 'unsafe-eval';
      style-src 'self' 'unsafe-inline';
      connect-src 'self' *.supabase.co *.supabase.com 127.0.0.1:* localhost:* 172.17.0.2:* 172.17.* 172.18.* 172.19.* 172.20.* *.orgadoro.com;
      img-src 'self' data: https:;
      font-src 'self' data:;
      base-uri 'self';
      form-action 'self';
    `.replace(/\s+/g, ' ').trim();
    document.head.appendChild(meta);
  }
  
  static preventClickjacking() {
    // Prevent the page from being loaded in a frame
    if (window !== window.top) {
      window.top.location = window.location;
    }
  }
  
  static setupSecurityHeaders() {
    // Add security headers to all fetch requests
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const [url, options = {}] = args;
      const secureOptions = {
        ...options,
        headers: {
          ...options.headers,
          'X-Admin-Request': 'true',
          'X-Request-Origin': window.location.origin,
          'X-Timestamp': Date.now().toString(),
          'X-Client-Version': process.env.REACT_APP_VERSION || '1.0.0'
        }
      };
      return originalFetch(url, secureOptions);
    };
  }
  
  static initializeNetworkSecurity() {
    try {
      this.setupCSP();
      this.preventClickjacking();
      this.setupSecurityHeaders();
      
      // Add CSP violation reporting
      document.addEventListener('securitypolicyviolation', (e) => {
        console.warn('🚨 CSP Violation:', {
          blockedURI: e.blockedURI,
          violatedDirective: e.violatedDirective,
          originalPolicy: e.originalPolicy
        });
      });
      
      console.log('✅ Network security initialized');
    } catch (error) {
      console.error('❌ Failed to initialize network security:', error);
      // Don't fail the application, but log the error
    }
  }
}
